import React from 'react';
import { useTranslation } from 'react-i18next';
import { CircleAlert, Upload, X } from 'lucide-react';

import CommonButton from '../../../../../components/common-button/CommonButton';
import CommonDropArea from '../../../../../components/common-drop-area/CommonDropArea';

import scss from './AssetDropArea.module.scss';

function AssetDropArea({ accept, multiple, disabled, error, onErrorClose, onFiles, onRejected, children }) {
  const { t } = useTranslation('settings');

  return (
    <CommonDropArea
      accept={accept}
      multiple={multiple}
      disabled={disabled}
      onDrop={onFiles}
      onDropRejected={onRejected}
      overlayIcon={<Upload size={28} strokeWidth={1.5} />}
      overlayLabel={t('mediaStudioDropToUpload')}
      className={scss.dropArea}
      contentClassName={scss.content}
      renderHeader={({ open }) => (
        <>
          <div className={scss.toolbar}>
            <CommonButton
              styleColor='secondary'
              maxWidth={140}
              LeftIcon={<Upload size={16} />}
              isStrokeIcon
              disabled={disabled}
              onClick={open}>
              {t('mediaStudioUpload')}
            </CommonButton>
          </div>

          {error ? (
            <div className={scss.error} role='alert'>
              <CircleAlert size={16} className={scss.errorIcon} />
              <p className={scss.errorText}>{t(error)}</p>
              <button type='button' className={scss.errorClose} aria-label={t('close')} onClick={onErrorClose}>
                <X size={14} />
              </button>
            </div>
          ) : null}
        </>
      )}>
      {children}
    </CommonDropArea>
  );
}

export default AssetDropArea;
